<template>
    <div class="upDocClass">
        <el-upload
            :limit="1"
            :on-exceed='beyondNum'
            :accept="TYPE"
            size="mini"
            multiple
            action=""
            ref="upload"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadHttp"
            :show-file-list="false"
            class="bosClass">

            <!-- 文件名/上传按钮    进度条/无    取消/删除 -->
            <div class="dContent1" :slot="(!url && !upBao)? 'trigger':'tip'" :style="{width:(!url && !upBao)?'100%':'45%'}">
                <span class="fileUpOkname" v-if="url || upBao"><b>{{url?url.split('/').pop():upIngName}}</b></span>
                <el-button v-if="!url && !upBao" slot="trigger" size="mini" type="primary" :loading="upBao" :style="styleEd" :class="networkError? 'errStyleUpDoc':''">
                    <i v-show="!upBao" class="el-icon-upload el-icon--right"></i> 
                    {{url? '上传完成':text}}
                </el-button>
            </div>

            <div class="dContent2" slot="tip">
                <!-- 进度 -->
                <el-progress v-if="upBao" :percentage="radioCheckedItem?Number(radioCheckedItem):0" style="width:100%"></el-progress>
                <span v-else-if="url" style="width:100%">
                    <el-progress :percentage="100" style="width:100%"></el-progress>
                </span>
            </div>
            
            <div class="dContent3" slot="tip">
                <!-- 取消上传 -->
                <el-button size="mini" v-if="upBao" @click.native.prevent="clearUpload" class="noUploading">取消上传</el-button>
                <!-- 删除 -->
                <el-button size="mini" v-else-if="url" @click="deleteFileFoo" class="noUploading" type="danger">删除</el-button>
                <!-- 删除空项 -->
                <slot name="kdelete" v-else-if="!url"></slot>
            </div>

        </el-upload>
    </div>
</template>
    
<script>
import utils from '../lib/util'
import zipOss from '../lib/zipOss'
export default {
    props:{
        limitSize:String,//大小限制 不传则不限制
        text:{
            type:String,
            default:'上传答案',
        },
        styleEd:{
            type:String,
            default:'',
        },
        TYPE:{
            type:String,
            default:'*',
        },
        networkError:{
            type:Boolean,
            default:false,
        },
        serial:{
            type:Number,
            default:false,
        },
        //唯一标识
        serialUuid:{
            type:String,
            default:''
        },
        fileOssUrl:{
            type:String,
            default:''
        }
    },
    data () {
        return {
            url:'',
            upBao:false,
            upIngName:'',
            videoSize:'0KB',
            radioCheckedItem:0,
            isCancel:false,
        }
    },
    components:{},
    computed:{
        // ressPuted_video:function(){
        //     let size = this.videoSize
        //     let saveGl = size.substring(size.length - 2)
        //     // let maxSize = this.$store.getters.is_docRess
        //     let maxSize = window.sessionStorage.getItem(`doc_${this.serial}`)
        //     return String(utils.unsingNumber(size.replace(/(KB|MB|GB|TB)/g,'')*(String(maxSize).replace(/(%)/g,'')/100),'floor',2))+saveGl
        // },
        // ressing:function(){
        //     // return this.$store.getters.is_docRess
        //     return window.sessionStorage.getItem(`doc_${this.serial}`)
        // },
    },
    watch:{
        deep:true,
        "$store.state.isZip":{
            deep: true,
            handler(val){
                let vl = eval("val.zipLoading.doc_"+String(this.serialUuid))
                if(vl!=undefined)
                this.radioCheckedItem = vl? vl:0
            }
        },
    },
    mounted: function () {
        this.editMet()
    },
    methods: {
        //编辑
        editMet(){
            if(!this.fileOssUrl)return
            this.url = this.fileOssUrl
        },
        //超出最大上传数量
        beyondNum(){
            this.$message.success('最大上传一个文件')
        },
        beforeAvatarUpload (file) {
            if(this.networkError){
                this.$alert('当前无网络或网络链接不稳定，请检查网络', '网络提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        return false;
                    }
                });
            }
            if(this.networkError){ //应上面弹框提示无法阻止程序
                return false;
            }
            // 命名：只能中英文 数字 、中划线、下划线、中划线和小括号 其他都不行
            let ref = /^[a-zA-Z0-9_\-（）()\u4e00-\u9fa5]+$/;
            let fileNames = file.name.substring(0,file.name.lastIndexOf(`.${file.name.split('.')[file.name.split('.').length - 1]}`))
            if(!ref.test(fileNames)){
                this.$message({
                    message:`文件名称不能包含特殊字符！文件名只能中英文、数字、中下划线、小括号组成。`,
                    duration:5000,
                    showClose: true,
                    type:'error',
                });
                return false;
            }
            
            // 限制文件格式
            const upFtype = file.name.split('.')[file.name.split('.').length - 1]
            if(!this.TYPE.split(',').find((son)=>son.indexOf(upFtype)>-1)){
                this.$message({
                    message:"上传文件格式不符合，请上传正确文件",
                    duration:5000,
                    showClose: true,
                    type:'error',
                });
                return false;
            }

            let isSize = this.limitSizeFoo(file.size,this.limitSize)
            if (!isSize) {
                this.$message.error(`上传文件大小不能超过 ${this.limitSize/1024}Mb!`);
            }
            return isSize;
            // return file;
        },
        limitSizeFoo(isSize,limitSize=null){//KB
            if(limitSize==null) return true
            isSize = isSize / 1000;
            if(Number(isSize)<=Number(limitSize)){
                return true
            }else{
                return false
            }
        },
        // 取消上传
        clearUpload(){
            if(this.networkError) {this.$message.error('当前网络不佳,请您稍后重试！');return}
            this.upBao = false
            this.isCancel = true
            this.$refs.upload.clearFiles();
            zipOss.abortMultipartUpload(this.serialUuid)
            this.$nextTick(function(){
                this.$emit('deleteNullItem',{'serialUuid':this.serialUuid})
            })
        },
        //删除已上传文件
        deleteFileFoo(){
            if(this.networkError) {this.$message.error('当前网络不佳,请您稍后重试！');return}
            this.$confirm('删除后无法恢复，是否确认删除？', '系统确认', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认删除',
                cancelButtonText: '再想想',
                type:'warning'
            })
            .then(() => {
                this.upBao = false
                this.$refs.upload.clearFiles();
                this.url = ''
                this.$emit('upImgUrl',{'serialUuid':this.serialUuid,'url':''})
            })
            .catch(()=>{})
        },
        //阿里云OSS上传
        uploadHttp({ file }) {
            let that = this
            that.upBao = true
            that.upIngName = file.name
            that.videoSize = String(utils.getFileSize(file.size))
            if(that.$route.query.userSignId)
            file['room'] = `${that.$route.query.bId}/${that.$route.query.userSignId}`
            else 
            file['room'] = `${that.$route.query.bId}` 
            zipOss.uploadHttp(file,function(e,val=''){
                // e 路径，val 空表示取消 非空表示上传中
                if(!e&&!that.isCancel) {
                    that.$refs.upload.abort()
                    that.$alert('系统检测到网络不佳，请您检查网络。网络恢复后将自动继续上传！', '上传暂停', {
                        confirmButtonText: '确定',
                        callback: action => {
                            return false;
                        }
                    });
                }else{
                    that.upIngName = ''
                }
                if(that.isCancel)
                that.isCancel = false
                if(!val)
                that.upBao = false
                if(e){
                    that.url = e
                    that.$emit('upImgUrl',{'serialUuid':that.serialUuid,'url':e})
                }
            },that.serialUuid)
        },
    }
}
</script>
<style scope>
    .upDocClass{
        position: relative;
    }
    .bosClass{
        /* pointer-events: none; */
    }
    .bosClass::after{
        content: '';
        height: 0px;
        display: block;
        overflow: hidden;
        clear: both;
    }
    .dContent1{
        float: left;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
    }
    .dContent2{
        float: left;
        width: 40%;
        height: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        height: 30px;
        line-height: 30px;
    }
    .dContent3{
        float: left;
        width: 15%;
        height: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 15px;
    }
    .fileUpOkname{
        width: 100%;
        overflow: hidden;
        word-wrap: break-word;
        color: #409eff;
    }
    .errStyleUpDoc{
        background-color: #909399 !important;
        border-color:#909399 !important;
    }
    .noUploading{
        /* pointer-events: all;
        z-index: 2045; */
    }
</style>


// WEBPACK FOOTER //
// src/components/upDoc.vue